import { render } from "./SchoolLicenseManageForm.vue?vue&type=template&id=41de2468&scoped=true"
import script from "./SchoolLicenseManageForm.vue?vue&type=script&lang=js"
export * from "./SchoolLicenseManageForm.vue?vue&type=script&lang=js"

import "./SchoolLicenseManageForm.vue?vue&type=style&index=0&id=41de2468&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41de2468"]])

export default __exports__